import { Mobile } from '@bimser/common';
import { findMessage } from '@bimser/components';
import { mobile } from '@bimser/core';
import { convertFieldsForMobile, handleRowsForMobile } from '.';
import { onSearchingChangeStatic } from '..';
import DataGrid from '../..';
import { primaryKeyControl } from './subscribeMobilEvents';

function getColumns(this: DataGrid) {
	return this.columns.map(column => {
		const filterOperations: any = {};

		switch (column.editType) {
			case 'numberBox': {
				filterOperations['equal'] = {
					text: findMessage.get('101711'),
					name: 'equal',
					symbol: '='
				};
				filterOperations['notEqual'] = {
					text: findMessage.get('101712'),
					name: 'notEqual',
					symbol: '<>'
				};
				filterOperations['greaterThan'] = {
					text: findMessage.get('101713'),
					name: 'greaterThan',
					symbol: '>'
				};
				filterOperations['graterThenOrEqual'] = {
					text: findMessage.get('101714'),
					name: 'graterThenOrEqual',
					symbol: '>='
				};
				filterOperations['lessThan'] = {
					text: findMessage.get('101715'),
					name: 'lessthan',
					symbol: '<'
				};
				filterOperations['lessThanOrEqual'] = {
					text: findMessage.get('101716'),
					name: 'lessThanOrEqual',
					symbol: '=<'
				};
				break;
			}
			case 'checkBox': {
				filterOperations['equal'] = {
					text: findMessage.get('101711'),
					name: 'equal',
					symbol: '='
				};
				filterOperations['notEqual'] = {
					text: findMessage.get('101712'),
					name: 'notEqual',
					symbol: '<>'
				};
				break;
			}
			case 'textBox':
			case 'multiLanguageTextBox':
			case 'comboBox': {
				filterOperations['contains'] = {
					text: findMessage.get('101718'),
					name: 'contains',
					symbol: 'contains'
				};
				filterOperations['notContains'] = {
					text: findMessage.get('101719'),
					name: 'notContains',
					symbol: 'notContains'
				};
				filterOperations['startsWith'] = {
					text: findMessage.get('101720'),
					name: 'startsWith',
					symbol: 'startsWith'
				};
				filterOperations['endsWith'] = {
					text: findMessage.get('101721'),
					name: 'endsWith',
					symbol: 'endsWith'
				};
				filterOperations['equal'] = {
					text: findMessage.get('101711'),
					name: 'equal',
					symbol: '='
				};
				filterOperations['notEqual'] = {
					text: findMessage.get('101712'),
					name: 'notEqual',
					symbol: '<>'
				};
				break;
			}
			case 'none':
				break;
			case 'timePicker':
			case 'datePicker':
			case 'dateTimePicker':
			case 'dateRangePicker': {
				filterOperations['greaterThan'] = {
					text: findMessage.get('101713'),
					name: 'greaterThan',
					symbol: '>'
				};
				filterOperations['graterThenOrEqual'] = {
					text: findMessage.get('101714'),
					name: 'graterThenOrEqual',
					symbol: '>='
				};
				filterOperations['lessThan'] = {
					text: findMessage.get('101715'),
					name: 'lessThan',
					symbol: '<'
				};
				filterOperations['lessThanOrEqual'] = {
					text: findMessage.get('101716'),
					name: 'lessThanOrEqual',
					symbol: '=<'
				};
				break;
			}
			default: {
				filterOperations['contains'] = {
					text: findMessage.get('101718'),
					name: 'contains',
					symbol: 'contains'
				};
				filterOperations['notcontains'] = {
					text: findMessage.get('101719'),
					name: 'notcontains',
					symbol: 'notcontains'
				};
				filterOperations['startsWith'] = {
					text: findMessage.get('101720'),
					name: 'startsWith',
					symbol: 'startsWith'
				};
				filterOperations['endsWith'] = {
					text: findMessage.get('101721'),
					name: 'endsWith',
					symbol: 'endsWith'
				};
				filterOperations['equal'] = {
					text: findMessage.get('101711'),
					name: 'equal',
					symbol: '='
				};
				filterOperations['notEqual'] = {
					text: findMessage.get('101712'),
					name: 'notEqual',
					symbol: '<>'
				};
				filterOperations['greaterThan'] = {
					text: findMessage.get('101713'),
					name: 'greaterThan',
					symbol: '>'
				};
				filterOperations['graterThenOrEqual'] = {
					text: findMessage.get('101714'),
					name: 'graterThenOrEqual',
					symbol: '>='
				};
				filterOperations['lessThan'] = {
					text: findMessage.get('101715'),
					name: 'lessThan',
					symbol: '<'
				};
				filterOperations['lessThanOrEqual'] = {
					text: findMessage.get('101716'),
					name: 'lessThanOrEqual',
					symbol: '=<'
				};
				break;
			}
		}

		const columnFiltering = this.__filtering.find(filter => filter.columnName === column.name);
		const columnSorting = this.__sorting.find(sort => sort.columnName == column.name);
		let filterChanged: boolean = false;
		let sortChanged: boolean = false;

		if (columnFiltering) {
			column.filtering.operation = columnFiltering.operation as any;
			column.filtering.value = columnFiltering.value;
			filterChanged = true;
		}
		if (columnSorting) {
			column.sorting.order = columnSorting.direction;
			sortChanged = true;
		}

		column['summaryValue'] = this.__summaryValue?.[column.name] || {};
		return { ...column, filterOperations, filterChanged, sortChanged };
	});
}

function setRows(this: DataGrid) {
	if (Mobile.MobileView.isAndroidAvaliable || Mobile.MobileView.isIosAvaliable) {
		if (
			(this.dataSource?.name && !this.dataSource.runAtServer) ||
			Object.values(this.__dataSourceLoadMap)?.length
		) {
			Mobile.MobileView.setFormDataGridRows({
				controlId: this.name,
				rows: handleRowsForMobile.call(this),
				count: this.__totalCount,
				pageIndex: this.paging.currentPage
			});
		} else {
			onSearchingChangeStatic.call(this);
		}
	}
}

export function getComponentData(this: DataGrid) {
	let handlePagination = false;

	if (
		mobile().any() &&
		this.__form.__mobileFormView === Mobile.MobileFormView.NativePlus &&
		this.saveMode !== 'self' &&
		this.dataSource &&
		(!this.dataSource.name.length || this.dataSource.runAtServer)
	) {
		this.paging.enabled = false;
		handlePagination = true;
	}

	const mobileControls = convertFieldsForMobile(
		this.columns as any,
		this.__editingColumnsValues,
		this.__columns,
		this.name,
		primaryKeyControl
	);
	Mobile.MobileView.setDataGridControlsProperties(mobileControls, this.name);
	setRows.call(this);
	return {
		columns: getColumns.call(this),
		rows: handleRowsForMobile.call(this),
		dataSource: this.dataSource,
		dataSourceType: this.dataSourceType,
		height: this.height,
		displayType: this.displayType,
		columnSettings: this.columnSettings,
		detailRow: this.detailRow,
		editing: this.editing,
		filtering: this.filtering,
		grouping: this.grouping,
		paging: this.paging,
		searching: this.searching,
		selection: this.selection,
		saveMode: this.saveMode,
		sorting: this.sorting,
		toolbarActionButtons: this.toolbarActionButtons,
		alternateColor: this.alternateColor,
		virtualScrolling: this.virtualScrolling,
		exportToExcel: this.exportToExcel,
		gridLines: this.gridLines,
		gridBorder: this.gridBorder,
		fields: convertFieldsForMobile(this.columns as any, undefined, this.__columns, this.name),
		primaryKey: this.getUniqueDataField(),
		totalCount: this.__totalCount,
		summaryTypeExist: this.columns.some(column => column.summaryTypePrefixes?.length),
		wordWrapEnabled: this.wordWrapEnabled,
		columnHidingEnabled: this.columnHidingEnabled,
		remoteOperation:
			(this.dataSource?.name && !this.dataSource.runAtServer) ||
			(this.__form.documentId > 0 && this.saveMode == 'self'),
		handlePagination
	};
}
